"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfValidateUpcomingShiftsDto = instanceOfValidateUpcomingShiftsDto;
exports.ValidateUpcomingShiftsDtoFromJSON = ValidateUpcomingShiftsDtoFromJSON;
exports.ValidateUpcomingShiftsDtoFromJSONTyped = ValidateUpcomingShiftsDtoFromJSONTyped;
exports.ValidateUpcomingShiftsDtoToJSON = ValidateUpcomingShiftsDtoToJSON;
exports.ValidateUpcomingShiftsDtoToJSONTyped = ValidateUpcomingShiftsDtoToJSONTyped;
/**
 * Check if a given object implements the ValidateUpcomingShiftsDto interface.
 */
function instanceOfValidateUpcomingShiftsDto(value) {
    if (!('hoursBeforeShift' in value) || value['hoursBeforeShift'] === undefined)
        return false;
    return true;
}
function ValidateUpcomingShiftsDtoFromJSON(json) {
    return ValidateUpcomingShiftsDtoFromJSONTyped(json, false);
}
function ValidateUpcomingShiftsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'hoursBeforeShift': json['hoursBeforeShift'],
    };
}
function ValidateUpcomingShiftsDtoToJSON(json) {
    return ValidateUpcomingShiftsDtoToJSONTyped(json, false);
}
function ValidateUpcomingShiftsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'hoursBeforeShift': value['hoursBeforeShift'],
    };
}
//# sourceMappingURL=ValidateUpcomingShiftsDto.js.map